module.exports = __webpack_public_path__ + "img/idea_text1.6aa61eda.png";